import React from 'react';
import { Card, Form } from 'react-bootstrap';

interface Question {
  id: number;
  text: string; // Backend returns language-specific text directly
  type: 'likert' | 'binary' | 'text' | 'yes_no';
  required: boolean;
  choices?: {
    id: number;
    text: string; // Backend returns language-specific text directly
    value: number;
  }[];
}

interface QuestionnaireFormProps {
  question: Question;
  language: 'en' | 'el';
  answer?: any;
  onAnswerChange: (answer: any) => void;
}

export function QuestionnaireForm({ 
  question, 
  language, 
  answer, 
  onAnswerChange 
}: QuestionnaireFormProps) {
  const handleRadioChange = (value: number) => {
    console.log('Radio changed:', { value, type: typeof value, questionId: question.id });
    onAnswerChange(value);
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onAnswerChange(event.target.value);
  };

  // Debug log the question choices
  console.log('Question choices:', question.choices?.map(c => ({ 
    id: c.id, 
    text: c.text, 
    value: c.value, 
    type: typeof c.value,
    isChecked: answer === c.value 
  })));
  console.log('Current answer:', answer, 'type:', typeof answer);

  return (
    <Card className="question-card">
      <Card.Body>
        <Card.Title className="h5 mb-4">
          {question.text}
        </Card.Title>

        {question.type === 'likert' && question.choices && (
          <div className="choices-container">
            {question.choices.map((choice) => (
              <div key={choice.id} className="mb-3">
                <Form.Check
                  type="radio"
                  id={`choice-${choice.id}`}
                  name={`question-${question.id}`}
                  value={choice.value.toString()}
                  checked={answer === choice.value}
                  onChange={() => {
                    console.log('Clicked choice:', { id: choice.id, text: choice.text, value: choice.value });
                    handleRadioChange(choice.value);
                  }}
                  label={choice.text}
                  className="choice-radio"
                />
              </div>
            ))}
          </div>
        )}

        {(question.type === 'binary' || question.type === 'yes_no') && (
          <div className="choices-container">
            <div className="mb-3">
              <Form.Check
                type="radio"
                id="choice-yes"
                name={`question-${question.id}`}
                value="yes"
                checked={answer === 'yes'}
                onChange={() => onAnswerChange('yes')}
                label={language === 'el' ? 'Ναι' : 'Yes'}
                className="choice-radio"
              />
            </div>
            <div className="mb-3">
              <Form.Check
                type="radio"
                id="choice-no"
                name={`question-${question.id}`}
                value="no"
                checked={answer === 'no'}
                onChange={() => onAnswerChange('no')}
                label={language === 'el' ? 'Όχι' : 'No'}
                className="choice-radio"
              />
            </div>
          </div>
        )}

        {question.type === 'text' && (
          <Form.Group>
            <Form.Control
              as="textarea"
              rows={4}
              value={answer || ''}
              onChange={handleTextChange}
              placeholder={language === 'el' 
                ? 'Παρακαλώ εισάγετε την απάντησή σας...' 
                : 'Please enter your answer...'
              }
            />
          </Form.Group>
        )}
      </Card.Body>
    </Card>
  );
}
